/**
 * Dashboard design tokens.
 * ────────────────────────────────────────────────────────────────────────────
 * Lifted verbatim from `views/Cart/CartScreen.js`, which is the newest and
 * cleanest look in the dashboard: navy gradient header band, white panels with
 * a 1px border and a soft shadow, uppercase letterspaced section strips.
 *
 * Two older systems exist alongside it — the `-adorned` stylesheet inlined into
 * nine product/vendor forms, and plain react-bootstrap cards. Neither is worth
 * a mass rewrite, but nothing NEW should add to either pile. Import these.
 *
 * CartScreen keeps its own local copy of the same values rather than importing
 * this file: it is a large screen, its copy is the source these were taken
 * from, and reaching in to change it earns a regression for no visible gain.
 * If the two ever need to diverge, this is the one that new screens follow.
 */
export const THEME = {
  bg: "#f4f6fb",
  panel: "#ffffff",
  header: "#1a2b4a",
  headerTo: "#243b6e",
  blue: "#2c7be5",
  blueDeep: "#1a5fc4",
  blueSoft: "#eaf2ff",
  teal: "#00b69b",
  tealSoft: "#e6faf7",
  red: "#e63757",
  redSoft: "#fff0f3",
  amber: "#f0a020",
  amberSoft: "#fff8ec",
  text: "#1a2b4a",
  textMid: "#4a5568",
  textLight: "#8898aa",
  border: "#e2e8f0",
  stripBg: "#fafbfd",
  shadow: "0 2px 12px rgba(26,43,74,0.08)",
  headerShadow: "0 4px 24px rgba(26,43,74,0.18)",
  radius: "10px",
  radiusSm: "6px",
};

export default THEME;
